export default "__VITE_ASSET__C_PPxK_G__"